/**
 * Repositions the "Customer Favorite" badge inside the Wizz price widget grid
 * so it appears below .product-hamsa and above .message-hamsa (if present).
 * Falls back to leaving it in place when the Wizz widget is absent.
 */
(function () {
  const BADGE_GRID_AREA = 'zw-customfav';
  const POSITIONED_ATTR = 'data-zw-badge-positioned';

  function positionBadge(badge) {
    if (badge.hasAttribute(POSITIONED_ATTR)) return;

    // The badge may be inside a wrapper div — move the wrapper if present
    const moveTarget = badge.closest('.card__best-seller-badge-wrap') || badge;

    const cardInfo = badge.closest('.card-information');
    if (!cardInfo) return;

    // Wizz injects duplicate IDs — use querySelector on the scoped element
    const wrapper = cardInfo.querySelector('[id="custom-price-wrapper"]');
    if (!wrapper) return;

    const layout = wrapper.querySelector('.layout');
    if (!layout) return;

    const productHamsa = layout.querySelector('.product-hamsa');
    if (!productHamsa) return;

    badge.setAttribute(POSITIONED_ATTR, '');

    // Inject a new grid row after the "product" row in grid-template-areas.
    // Each row must have the same number of columns, so repeat the area name
    // to match the column count of the existing rows.
    const areas = layout.style.gridTemplateAreas;
    if (areas) {
      const rows = areas.match(/"[^"]*"/g) || [];
      const productRowIdx = rows.findIndex((r) => r.includes('product'));
      if (productRowIdx !== -1) {
        const colCount = rows[productRowIdx].replace(/"/g, '').trim().split(/\s+/).length;
        const newRow = `"${Array(colCount).fill(BADGE_GRID_AREA).join(' ')}"`;
        moveTarget.style.gridArea = BADGE_GRID_AREA;
        rows.splice(productRowIdx + 1, 0, newRow);
        layout.style.gridTemplateAreas = rows.join(' ');
      }
    }

    const messageHamsa = layout.querySelector('.message-hamsa');
    if (messageHamsa) {
      layout.insertBefore(moveTarget, messageHamsa);
    } else {
      productHamsa.insertAdjacentElement('afterend', moveTarget);
    }
  }

  function scanBadges(root) {
    root
      .querySelectorAll(`.card__best-seller-badge:not([${POSITIONED_ATTR}])`)
      .forEach(positionBadge);
  }

  const observer = new MutationObserver(() => scanBadges(document));
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scanBadges(document));
  } else {
    scanBadges(document);
  }
})();
